import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AtlCardEvents, AtlContactCardProps, CardTags } from './card.types.ts';
import classNames from 'classnames';
import { getGlobalStyleSheets } from '../../global-styles';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement(CardTags.ContactCard)
export class AtlContactCard extends LitElement implements AtlContactCardProps {

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   @property({ type: String })
   internalId?: string;

   @property({ type: String })
   internalClassName?: string;

   @property({ type: String })
   initials: string;

   @property({ type: String })
   cardTitle: string;

   @property({ type: String })
   avatar?: string;

   @property({ type: String })
   avatarAlt?: string;

   @property({ type: Boolean })
   fixedSize?: boolean;

   @property({ type: Boolean })
   cursorPointer?: boolean;

   @property({ type: Boolean })
   hoverElevation?: boolean;

   @property({ type: Boolean })
   highlighted?: boolean;

   render() {
      const title = () => {
         if (this.cardTitle?.length > 0) {
            return html` <span class="card-title"> ${this.cardTitle} </span> `;
         }

         return nothing;
      };
      const avatar = () => {
         if (this.avatar) {
            return html`
               <span class="card-title">
                  <img src="${this.avatar}" alt=${ifDefined(this.avatarAlt)} />
               </span>
            `;
         }
         if (this.initials) {
            return html` <div data-letters=${this.initials}></div> `;
         }

         return nothing;
      };

      return html`
         <div
            id=${this.internalId ?? 'atl-contact-card-id'}
            class=${classNames(
               'card contact-card',
               { 'fixed-size': this.fixedSize === true },
               { clickable: this.cursorPointer === true },
               { 'hover-elevation': this.hoverElevation === true },
               this.internalClassName
            )}
            @click=${() => this._handleCardClick()}
            part="contact-card"
         >
            ${title()}
            <div class="card-body">
               <div class="contact-item">
                  <div
                     class=${classNames(
                        'contact-avatar',
                        this.highlighted && 'highlighted'
                     )}
                  >
                     ${avatar()}
                  </div>
                  <div class="contact-text">
                     <slot name="slotContactText"></slot>
                  </div>
               </div>
               <div class="contact-cta">
                  <slot name="slotCta"></slot>
               </div>
            </div>
         </div>
      `;
   }

   protected _handleCardClick() {
      if (this.cursorPointer) {
         const event = new CustomEvent(AtlCardEvents.ContactCardClick, {
            bubbles: true,
            composed: true,
         });
         this.dispatchEvent(event);
      }
   }
}
